module.exports = require('./helpers/bundle-url').getBundleURL('aK4Nu') + "BaseLogo.e87313d9.svg";